import axiosV2Instance from './axiosV2Instance';

/** Результат начисления компенсации за выезд по одной смене */
export interface CompensationAccrualResult {
  sessionId: number;
  /** created | already_exists | no_rate | not_closed | not_found | no_activity */
  status: string;
  amount?: number | null;
}

class EarningsV2Api {
  /**
   * Пакетное ручное начисление компенсации по закрытым сменам: сумма за каждую смену + комментарий.
   * Идемпотентно: по смене начисляется не больше одной компенсации. Требуется FINANCE_EDIT.
   */
  async accrueSessionCompensations(
    siteId: number,
    sessionIds: number[],
    amount: number,
    comment?: string
  ): Promise<CompensationAccrualResult[]> {
    const response = await axiosV2Instance.post<CompensationAccrualResult[]>(
      `/sites/${siteId}/earnings/compensations`,
      { sessionIds, amount, comment: comment || '' }
    );
    return response.data;
  }
}

export const earningsV2Api = new EarningsV2Api();
